export default __webpack_public_path__ + "static/media/dark-forest.cd773d1c.jpg";